import type { IndexMeta } from '../types/Api/Response/IndexMeta'

/**
 * Filter helper service
 */
export class FilterService {
    private _meta: IndexMeta
    constructor(meta: IndexMeta) {
        // const { $translate, $formatDate, $formatDateTime, $config, $getColor } = useNuxtApp()
        // this.$translate = $translate
        // this.$formatDate = $formatDate
        // this.$formatDateTime = $formatDateTime
        // this.$config = $config
        // this.$getColor = $getColor
        this._meta = meta
    }

    /**
     * Keep current filters from query that are not defined in allowedFilter ( hidden filters )
     *
     * @param filterNames hidden filter set by i3pService
     */
    getHiddenFiltersQuery(filterNames: string[] = []): any {
        const currentRequestFilter = { ...this._meta.request.filter }
        this._meta.allowed_filters.forEach((filter) => {
            if (!filterNames.includes(filter.name)) {
                delete currentRequestFilter[filter.name]
            }
        })

        return currentRequestFilter
    }

    // TODO move methods here ...
}
